<template>
	<div class="booker-delivery-button">
		<ButtonCustom class="booker-delivery-button__button" :class="{ 'booker-delivery-button__button--on': isTurnOn }" @click="changeTab"
			><div class="booker-delivery-button__content">
				<GlobalSwitch v-model="isTurnOn"></GlobalSwitch
				>{{
					type === EBookerLocationType.START
						? $t('components.booker.car_delivery.car_at_your_own_address')
						: $t('components.booker.car_delivery.car_from_your_own_address')
				}}
			</div>
			<GlobalIcon name="routing" :height="24" class="booker-delivery-button__icon"></GlobalIcon>
		</ButtonCustom>
	</div>
</template>

<script lang="ts" setup>
import { EBookerLocationType } from '@/data/bookerData'
const tab = inject<Ref<string>>('tab')!
const isTurnOn = ref(false)

defineProps<{ type: EBookerLocationType }>()

const changeTab = () => {
	if (tab.value === 'delivery') tab.value = 'default'
	else tab.value = 'delivery'
}

watch(
	() => tab.value,
	() => {
		if (tab.value === 'default') {
			isTurnOn.value = false
		}
		if (tab.value === 'delivery') {
			isTurnOn.value = true
		}
	},
	{ immediate: true },
)
</script>

<style lang="scss">
@import './Button';
</style>
